export default __webpack_public_path__ + "static/media/jaw-top.73e21d1c.svg";